import i18n from "../translate/i18n";
export function formatDateTimeUTC(value: string) {
  const dateObj = new Date(value);
  const date = dateObj.getUTCDate().toString().padStart(2, "0") + "/" + (dateObj.getUTCMonth()+1).toString().padStart(2, "0") + "/" + dateObj.getUTCFullYear();
  let hours = dateObj.getUTCHours();
  const minutes = dateObj.getUTCMinutes().toString().padStart(2,"0");
  const ampm = i18n.language === "en" ? hours >= 12 ? "PM" : "AM" : hours >= 12 ? "م" : "ص";
  hours = hours % 12 || 12;

  const time = `${hours}:${minutes} ${ampm}`;

  return { date, time };
}